'use client';

import type { LinkNode } from '@prezly/story-content-format';
import type { ReactNode } from 'react';

import { Link } from '@/components/Link/Link';
import { StoryLink } from '@/lib/tracking';
import { segment } from '@/lib/tracking/segmentAnalytics';

interface Props {
    node: LinkNode;
    children?: ReactNode;
}

export function TrackedLink({ node, children }: Props) {
    const { href } = node;

    function handleClick() {
        segment.track(StoryLink.CLICK, { href });
    }

    return (
        <Link href={node.href} shouldOpenInNewTab={node.new_tab} onClick={handleClick}>
            {children}
        </Link>
    );
}
